import localStorageKeys from '@/constants/localStorageKeys';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
export const userReactionAtom = atomWithStorage(localStorageKeys.USER_REACTIONS, {});
const storage = createJSONStorage(() => sessionStorage);
export const reactionTableLimitAtom = atomWithStorage(localStorageKeys.REACTION_TABLE_LIMIT, 20, storage);